export const STATUS_REQUEST_DIGITAL_CERTIFICATE_LABEL = {
    1: {
        label: "Nháp",
        class: "magenta"
    },
    2: {
        label: "Chờ duyệt",
        class: "orange"
    },
    3: {
        label: "Nghiệp vụ từ chối",
        class: "red"
    },
    4: {
        label: "Nghiệp vụ đã duyệt ",
        class: "geekblue"
    },
    5:{
        label: "Đã sinh chứng thư số",
        class: "green"
    }
};